module.exports = __webpack_public_path__ + "static/media/honeybadger.bff0aa43.png";